import React from "react";
import SpecialSlider from "../../../Components/SpecialSlider/SpecialSlider";
import FlipCard from "../../../Components/FlipCard/FlipCard.view";

import { ReactComponent as Stars } from "./Assets/stars.svg";
import { ReactComponent as SandWatch } from "./Assets/sandWatch.svg";
import { ReactComponent as Ticket } from "./Assets/ticket.svg";
import { ReactComponent as Sale } from "./Assets/salePrice.svg";

import ZixxarLogo from "./Assets/zixxar-x-logo.png";
import S4FLogo from "./Assets/s4f-deschis1.png";
import UntoldLogo from "./Assets/untold-gold-logo.png";

import BeachAddonImg from "./Assets/sczxdv231.png";
import BungalowAddonImg from "./Assets/wsdf341.png";

import { FiArrowRight } from "react-icons/fi";

import { useCountdownLogic } from "./EventsSlider.logic";

import "./EventsSlider.style.scss";

const EventsSlider = () => {
  const { getTimeUnits, remainingTime } = useCountdownLogic();

  const { days, hours, minutes, seconds } = getTimeUnits(remainingTime);

  return (
    <section
      id="events-slider-section"
      className="events-slider-section position-relative"
    >
      <div className="container">
        <SpecialSlider>
          {/* <div className="d-flex gap-4"> */}
          <div className="event-slider-card d-flex gap-4">
            {/* card 1 */}
            <div className="card-1 text-white">
              <div className="tickets-available d-flex align-items-center justify-content-center">
                <Stars />

                <p className="font-pnb font-size-18 lh-1 mb-0">
                  200 Tickets Available
                </p>
              </div>

              <h1 className="event-title font-pnb font-size-48 text-center">
                Event <br /> Tickets
              </h1>

              <div className="price-increase-countdown d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex align-items-center justify-content-center gap-1 font-pnsb font-size-16">
                  <SandWatch />
                  Price increases in:
                </div>

                <div className="d-flex align-items-center justify-content-center gap-2">
                  <span className="font-pnsb font-size-32">{days}d</span>

                  <span className="font-pnsb font-size-32">{hours}h</span>

                  <span className="font-pnsb font-size-32">{minutes}m</span>

                  <span className="font-pnsb font-size-32">{seconds}s</span>
                </div>
              </div>

              <button
                onClick={() =>
                  window.open(
                    "https://shop.zixxar.net/platform-shop?category=Tickets"
                  )
                }
                className="btn-secure mx-auto"
              >
                <span className="font-size-18 font-pnr d-flex gap-2">
                  <Ticket /> Get tickets
                </span>
              </button>
            </div>
            {/* card 2 */}
            <FlipCard
              frontContent={
                <div className="front card-2 text-white d-flex flex-column">
                  <div className="top-small-tag mx-auto"></div>
                  <h1 className="private-title font-adr font-size-42 text-center">
                    Private <br /> Event Acces
                  </h1>
                  <div className="private-date-info d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex align-items-center justify-content-center gap-1 font-pnm font-size-20 lh-1">
                      3 Nights | September 2024
                    </div>
                  </div>

                  <div className="price-wrapper d-flex justify-content-center align-items-center">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <p className="font-pnsb font-size-16 mb-0 lh-1 mb-2">
                        Current Price
                      </p>
                      <p className="font-pnsb font-size-32 mb-0 lh-1">$4.000</p>
                    </div>

                    <div className="vr"></div>

                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <div className="d-flex justify-content-center align-items-center gap-1 mb-2">
                        <Sale />

                        <p className="font-pnsb font-size-16 mb-0 lh-1 ">
                          Next Price
                        </p>
                      </div>

                      <p className="sale-price font-pnsb font-size-32 mb-0 lh-1">
                        $4.500
                      </p>
                    </div>
                  </div>

                  <div className="zixxar-paradise mx-auto">
                    <h3 className="font-adr font-size-28">#ZIXXARPARADISE</h3>

                    <div className="d-flex align-items-center justify-content-center">
                      <p className="font-pnsb font-size-22 mb-0 lh-1">MALE</p>

                      <div className="vr"></div>

                      <p className="font-pnsb font-size-22 mb-0 lh-1">
                        MALDIVES
                      </p>
                    </div>
                  </div>

                  <div className="logos-wrapper d-flex justify-content-between align-items-center">
                    <img src={UntoldLogo} alt="untold logo" />
                    <img src={S4FLogo} alt="s4f logo" />
                    <img src={ZixxarLogo} alt="zixxar logo" />
                  </div>
                </div>
              }
              backContent={
                <div className="back card-2 text-white">
                  <div className="top-small-tag mx-auto"></div>

                  <div className="info-title font-pnsb font-size-20 lh-1">
                    This ticket ensures your ZiXXarParadise access. It offers
                    access to all the activities included in this event:
                  </div>

                  <div className="info-list d-flex flex-column gap-2">
                    <div className="d-flex align-items-center gap-1 font-pnm font-size-16">
                      <FiArrowRight />
                      ZiXXar Training
                    </div>

                    <div className="d-flex align-items-center gap-1 font-pnm font-size-16">
                      <FiArrowRight />
                      Untold Parties
                    </div>

                    <div className="d-flex align-items-center gap-1 font-pnm font-size-16">
                      <FiArrowRight />
                      Sense4Fit sport activities
                    </div>

                    <div className="d-flex align-items-center gap-1 font-pnm font-size-16">
                      <FiArrowRight />
                      and more...
                    </div>
                  </div>

                  <div className="info-accommodation d-flex flex-column gap-2 font-pnsb font-size-20 lh-1">
                    Accomodation:
                    <div className="d-flex align-items-center gap-1 font-pnm font-size-16 mb-2">
                      <FiArrowRight />
                      Provided by us
                    </div>
                    Transport:
                    <div className="d-flex align-items-center gap-1 font-pnm font-size-16">
                      <FiArrowRight />
                      Up to $700 reimbursement.
                    </div>
                  </div>
                </div>
              }
            />

            {/* Card 3 */}
            <FlipCard
              frontContent={
                <div className="front card-3 text-white d-flex flex-column">
                  <div className="top-small-tag mx-auto"></div>
                  <h1 className="beach-title font-adr font-size-42 text-center">
                    Beach View <br /> Experience
                  </h1>

                  <div className="beach-date-info d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex align-items-center justify-content-center gap-1 font-pnm font-size-20 lh-1">
                      3 Nights | September 2024
                    </div>
                  </div>

                  <div className="ticket-addon d-flex flex-column justify-content-center align-items-center">
                    <p className="available-with font-size-12 font-adr">
                      available with
                    </p>

                    <img src={BeachAddonImg} alt="addon" className="addon" />

                    <div className="addon-tag d-flex justify-content-center align-items-center">
                      <Stars />

                      <p className="font-pnm font-size-14 mb-0 lh-1">
                        TICKET ADDON
                      </p>
                    </div>
                  </div>

                  <div className="zixxar-paradise mx-auto">
                    <h3 className="font-adr font-size-28">#ZIXXARPARADISE</h3>

                    <div className="d-flex align-items-center justify-content-center">
                      <p className="font-pnsb font-size-22 mb-0 lh-1">MALE</p>

                      <div className="vr"></div>

                      <p className="font-pnsb font-size-22 mb-0 lh-1">
                        MALDIVES
                      </p>
                    </div>
                  </div>
                </div>
              }
              backContent={
                <div className="back card-3 text-white">
                  <div className="top-small-tag mx-auto"></div>

                  <div className="addon-tag d-flex justify-content-center align-items-center mx-auto">
                    <Stars />

                    <p className="font-pnm font-size-14 mb-0 lh-1">
                      TICKET ADDON
                    </p>
                  </div>

                  <div className="ticket-addon d-flex flex-column justify-content-center align-items-center">
                    <p className="available-with font-size-12 font-adr">
                      available with
                    </p>

                    <img src={BeachAddonImg} alt="addon" className="addon" />
                  </div>

                  <div className="hr"></div>

                  <span className="info-title font-pnr font-size-16 lh-1 text-center">
                    This is not a ticket. It is a ticket add-on available
                    exclusively for LivePot Octarine owners and cannot be
                    purchased.
                    <br />
                    <br />
                    LivePot Octarine owners that purchase and claim Private
                    Event Access will experience upgraded accommodation,
                    specifically beachview rooms.
                  </span>

                  {/* <div className="zixxar-paradise mx-auto">
                    <h3 className="font-adr font-size-28 text-center">
                      #ZIXXARPARADISE
                    </h3>

                    <div className="d-flex align-items-center justify-content-center">
                      <p className="font-pnsb font-size-22 mb-0 lh-1">MALE</p>

                      <div className="vr"></div>

                      <p className="font-pnsb font-size-22 mb-0 lh-1">
                        MALDIVES
                      </p>
                    </div>
                  </div> */}
                </div>
              }
            />

            {/* Card 4 */}

            <FlipCard
              frontContent={
                <div className="front card-4 text-white d-flex flex-column">
                  <div className="top-small-tag mx-auto"></div>
                  <h1 className="bungalow-title font-adr font-size-42 text-center">
                    Bungalow <br /> Experience
                  </h1>

                  <div className="bungalow-date-info d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex align-items-center justify-content-center gap-1 font-pnm font-size-20 lh-1">
                      3 Nights | September 2024
                    </div>
                  </div>

                  <div className="ticket-addon d-flex flex-column justify-content-center align-items-center">
                    <p className="available-with font-size-12 font-adr">
                      available with
                    </p>

                    <img src={BungalowAddonImg} alt="addon" className="addon" />

                    <div className="addon-tag d-flex justify-content-center align-items-center">
                      <Stars />

                      <p className="font-pnm font-size-14 mb-0 lh-1">
                        TICKET ADDON
                      </p>
                    </div>
                  </div>

                  <div className="zixxar-paradise mx-auto">
                    <h3 className="font-adr font-size-28">#ZIXXARPARADISE</h3>

                    <div className="d-flex align-items-center justify-content-center">
                      <p className="font-pnsb font-size-22 mb-0 lh-1">MALE</p>

                      <div className="vr"></div>

                      <p className="font-pnsb font-size-22 mb-0 lh-1">
                        MALDIVES
                      </p>
                    </div>
                  </div>
                </div>
              }
              backContent={
                <div className="back card-4 text-white">
                  <div className="top-small-tag mx-auto"></div>

                  <div className="addon-tag d-flex justify-content-center align-items-center mx-auto">
                    <Stars />

                    <p className="font-pnm font-size-14 mb-0 lh-1">
                      TICKET ADDON
                    </p>
                  </div>

                  <div className="ticket-addon d-flex flex-column justify-content-center align-items-center">
                    <p className="available-with font-size-12 font-adr">
                      available with
                    </p>

                    <img src={BungalowAddonImg} alt="addon" className="addon" />
                  </div>

                  <div className="hr"></div>

                  <span className="info-title font-pnr font-size-16 lh-1 text-center">
                    This is not a ticket. It is a ticket add-on available
                    exclusively for Travel Master Octarine owners and cannot be
                    purchased.
                    <br />
                    <br />
                    Travel Master Octarine owners that purchase and claim
                    Private Event Access will experience upgraded accommodation,
                    specifically Bungalow rooms.
                  </span>

                  {/* <div className="zixxar-paradise mx-auto">
                    <h3 className="font-adr font-size-28 text-center">
                      #ZIXXARPARADISE
                    </h3>

                    <div className="d-flex align-items-center justify-content-center">
                      <p className="font-pnsb font-size-22 mb-0 lh-1">MALE</p>

                      <div className="vr"></div>

                      <p className="font-pnsb font-size-22 mb-0 lh-1">
                        MALDIVES
                      </p>
                    </div>
                  </div> */}
                </div>
              }
            />
          </div>
          {/* </div> */}
        </SpecialSlider>
      </div>
    </section>
  );
};

export default EventsSlider;
